// src/services/parasutApi.js

export async function exchangeCodeForToken(code) {
  // örnek yapı
  const response = await fetch('https://api.parasut.com/oauth/token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      grant_type: 'authorization_code',
      client_id: 'CLIENT_ID',
      client_secret: 'CLIENT_SECRET',
      code: code,
      redirect_uri: 'urn:ietf:wg:oauth:2.0:oob',
    }),
  });

  if (!response.ok) throw new Error('Token alınamadı');

  const data = await response.json();
  return data;
}
